<template>
  <ion-row>
    <ion-col>
      <ion-badge
        v-if="isOnline"
        class="online"
      >
        Online
      </ion-badge>
      <ion-badge
        v-else
        class="offline"
      >
        Offline
      </ion-badge>
    </ion-col>

    <ion-col>
      {{ item.serial_number }}
    </ion-col>

    <ion-col>
      {{ item.facilityName }}
    </ion-col>

    <ion-col size="2">
      <template v-if="item.cachedBridge">
        <template v-if="item.cachedBridge.is_online">
          Online (for {{ item.cachedBridge.last_connectivity_event | period }})
        </template>
        <template>
          -
        </template>
      </template>
      <template v-else>
        -
      </template>
    </ion-col>

    <ion-col>
      <code :title="item.balena_id">
        {{ item.balena_id.substring(0, 7) }}
      </code>

      <ion-button 
        v-clipboard:copy="item.balena_id" 
        class="uuid-clipboard" 
        fill="outline"
        size="small"
      >
        <ion-icon
          :src="i.clipboardOutline"
          mode="ios"
        />
      </ion-button>
    </ion-col>

    <ion-col size="2">
      <template v-if="item.cachedBridge">
        {{ item.cachedBridge.os_version }} / {{ item.cachedBridge.os_variant }}
      </template>
      <template v-else>
        -
      </template>
    </ion-col>

    <ion-col>
      {{ get('cachedBridge.ip_address') | optional }} 
    </ion-col>

    <ion-col>
      {{ get('commit.version') | optional }} 
    </ion-col>
  </ion-row>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isOnline() {
      return this.item.cachedBridge && this.item.cachedBridge.is_online
    }
  },
  methods: {
    get(path) {
      return _.get(this.item, path)
    }
  }
}
</script>